import React, { Component } from "react";
import { Button } from "../../../common/Button/Button";
import moment from 'moment';

class AuditLogDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listOpen: false,
      headerTitle: this.props.title
    };
  }

  componentDidUpdate() {
    const { listOpen } = this.state;
    setTimeout(() => {
      if (listOpen) {
        window.addEventListener("click", this.close);
      } else {
        window.removeEventListener("click", this.close);
      }
    }, 0);
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.close);
  }

  close = (timeOut) => {
    this.setState({
      listOpen: false
    });
  }

  toggleList() {
    this.setState(prevState => ({
      listOpen: !prevState.listOpen
    }));
  }

  renderAuditTrail = () => {
    const {auditLog = []} = this.props;
    return auditLog.map((audit,i) => {
      return(
        <div className="mt-2" key={i}>
          <div className="flex justify-content-between">
            <small>{audit.refHH||audit.reqUser}</small>
            <small>{moment(audit.dtCreated).format('lll')}</small>
          </div>
          {audit.bSPEntry?
          (
            <div className="audit-body mt-2">
              <div><small>Follow up (by Service Partner) on</small></div>
              {audit.dtFollowupOn?moment(audit.dtFollowupOn).format('ll'):""}
                <div>
                  <small>Completed</small>
                </div>
                {audit.bHandled ? "Yes" : "No"}
            </div>
          ):
          (
          <div className="audit-body mt-2">
            <div><small>Notes</small></div>
            {audit.sNotesHH||audit.sNotes}
            {audit.sModule?(""):
            (
              <>
                <div><small>Followup Actions</small></div>
                {audit.sFollowupAction}
                <div><small>Follow up on</small></div>
                {audit.dtFollowupOn?moment(audit.dtFollowupOn).format('ll'):""}
              </>
            )}
          </div>)}
        </div>
      )
    })
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(this.state.listOpen !== nextState.listOpen) return true;
    if(this.props.auditLog === nextProps.auditLog) return false;
    return true;
  }
  
  render() {
    const { listOpen } = this.state;
    const {auditLog} = this.props;
    return (
      <div>
        <div className="dd-header" onClick={() => this.toggleList()}>
          <div className="dd-header-title">
            <Button>Trail</Button>
          </div>
        </div>
        {listOpen && (
          <div className="dd-list audit">
            <div>
              {this.renderAuditTrail()}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default AuditLogDropdown;
